import _ from 'lodash'
import Backbone from 'backbone'
import template from './slides-edit.hbs'
import DisplayHeader from 'scoreboard/components/display-header'
import SlideForm from './slide-form'
import EditButtons from 'scoreboard/components/edit/edit-buttons'
import FormView from 'scoreboard/components/form-view'
import formHelper from 'scoreboard/components/form-helper'
import conductor from 'scoreboard/components/conductor'
import spectator from 'scoreboard/components/spectator'
import AttachOrglessV2Report from 'scoreboard/bookmarks/attach-orgless-v2-report'
import i18n from 'scoreboard/components/i18n'
import ExternalSlideForm from './external-slide-form'
import highlight from 'scoreboard/components/highlight'
import tabs from '../components/tabs'

var SlidesEdit = Backbone.View.extend({

	// this.model is a Slide

	tagName: 'form',

	className: 'table-hack display-layout slides-edit',

	events: {
		'click .cancel': 'cancel',
		'click .go-to-origin': 'navigateToSpectated',
		'click .save-to-organization': 'saveToOrganization'
	},

	initialize: function() {
		this.spectated = this.model.get('spectated') || this.model.get('label')
		this.formView = new FormView({
			el: this.el,
			toggleCancel: true,
			submit: this.submit.bind(this)
		})

		this.isExternalUrl = spectator.isCurrentExternalUrl()
		let itemContext = {
			type: this.isExternalUrl ? 'externalUrl' : _.get(this.spectated, 'type'),
			subtype: this.isExternalUrl ? 'externalUrl' : _.get(this.spectated, 'subtype'),
			section: this.isExternalUrl ? conductor.section() : conductor.section(this.model.get('url'))
		}

		if (this.isExternalUrl) {
			this._slideForm = new ExternalSlideForm({model: this.model, itemContext})
		} else {
			this._slideForm = new SlideForm({model: this.model, itemContext})
		}
		this._slideForm.on('change', this.formView.change.bind(this.formView))
	},

	render: function () {
		spectator.setCurrent(this.model)

		// Setup the header here.
		var url = spectator.getCurrentUrl()
		var section = conductor.section(url)
		var headerContext = {
			id: conductor.id(url),
			section: section
		}

		// If this is an external url, the tabs are 'View' & 'Edit Slide'
		if (this.isExternalUrl) {
			_.extend(headerContext, {
				overviewTabCode: i18n.get('common.view'),
				urlOverride: url
			})
		}

		// break out of circular dependency
		let metadataTabs = tabs[section].tabs(headerContext)
		this._header = new DisplayHeader({
			heading: this.spectated.label,
			staticHeading: true,
			model: this.model,
			subsection: 'edit',
			tabs: metadataTabs
		}).render()

		// setup buttons
		var pasteUrl = 'api/briefings/' + this.model.get('briefingId') +
			'/slides/' + this.model.id
		// #30209 specific delete confirmation message for slides
		let substitution = highlight(_.get(this.model.attributes, 'label'))
		let confirmDeleteMessage =
			i18n.get('briefingBooks.slide.delete.confirmation', substitution)
		this._editButtons = new EditButtons({
			section: 'briefings',
			model: this.model,
			pasteAllowed: function(node, parent, emptyOrg, mode) {
				var isBriefing = parent && parent.type === 'briefing'
				var moveToSameBb = mode === 'move' && parent != null
					&& this.model.get('briefingId') == parent.id
				return isBriefing && !moveToSameBb
			}.bind(this),
			pasteUrl: pasteUrl,
			confirmDeleteMessage
		}).render()

		// render to the DOM
		this.$el.empty()
			.append(this._header.el, template({ hasBanner: !this.isExternalUrl }))

		// The header has now been rendered. It comes from metadataObjects which
		// means the tabs are going to be pointing to non-briefings related urls.
		// Here, we do a few things to maintain consistency across briefing slides
		// and fix the urls #28354.
		let slideUrl = spectator.buildSpectatedUrl(this.model)
		this._header.$el.find('.tabs > .tab:not(.edit-tab):first-child a')
			.text(i18n.get('common.view')) // Tab should read 'View'
			.attr('href', slideUrl) // Tab url should point to the slide, not the original object
		this._header.$el.find('.edit-tab a')
			.text(i18n.get('briefingBooks.slide.edit.title')) // Tab should read 'Edit Slide'
			.attr('href', slideUrl + '/edit') // Tab url should point to the slide edit page

		if (section.indexOf('reports') != -1 && !_.isNil(this.spectated.briefingBookOrganizationId)) {
			let model = new Backbone.Model(this.spectated)
			_.invoke(this._attachV2Report, 'remove')
			this._attachV2Report = new AttachOrglessV2Report({el: this.$('.scroll-container'), model}).render()
			this._attachV2Report.on('done', orgId => {
				this.spectated.organizationId = orgId
				this.spectated.briefingBookOrganizationId = null
				this.render()
			})
			return this
		} else {
			this.$('.scroll-container').append(this._slideForm.el)
			this._slideForm.render()
			this.$('.edit-buttons-container').append(this._editButtons.$el.addClass('edit-buttons-bottom'))
		}

		// remove the "Choose Name" header to match other edit screens
		this.$('.label-panel .panel-header').remove()

		this.formView.start()

		return this
	},

	cancel: function() {
		this._slideForm.writeToDom()

		// #55024 writing to the DOM (above) triggers change events on the form,
		// so restart the form view in the nextTick to avoid those effects
		process.nextTick(() => this.formView.start())
	},

	submit: function(e) {
		e && e.preventDefault()
		if (this._slideForm.labelField.validate()) {
			this.formView.primaryButton.disable()
			return
		}

		var data = formHelper.readFromDom(this.el)
		return this.model.save(data, {
			patch: true,
			success: function(model) {
				this.formView.start()
				Backbone.trigger('edit:domain-object', model)
				this._header.adjustPeriod(data.periodId)
			}.bind(this),
			error: (model, response) => {
				if (response.responseJSON.messageCode
					=== 'dashboards.embeddedContent.blocked') {
					this._slideForm.webAddressField.error()
				}
				this.formView.error(response)
			}
		})
	},

	navigateToSpectated: function () {
		conductor.navigateToSpectated(spectator.getCurrentUrl(), this.spectated)
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.formView, this._header, this._slideForm, this._editButtons, this._attachV2Report], 'remove')
	}

})

export default SlidesEdit

SlidesEdit.__filename__ = 'briefings/slides-edit.js'
